



































































































import {
  Component, Vue, Prop, Watch, Ref,
} from 'vue-property-decorator';
import { ElForm } from 'element-ui/types/form.d';
import { submitAuth } from 'service/api';
import cardSide1 from 'assets/userCenter/accountInfo/card-side1.png';
import cardSide2 from 'assets/userCenter/accountInfo/card-side2.png';
import cardFail from 'assets/userCenter/accountInfo/card-fail.png';

interface Info {
  userName: string;
  idCard: string;
  idCardType: string;
  pictureFacade: string;
  pictureObverse: string;
}

interface PictureUploadRes {
  state: boolean;
  id: number;
  pictureFacade?: string;
  pictureObverse?: string;
  message: string;
}

@Component
export default class AuthInfo extends Vue {
  @Ref('form') readonly form!: ElForm;

  @Prop({ default: 0 }) authentication!: number;

  @Prop(Object) value!: Info;

  @Watch('value')
  onValueChange(val: Info) {
    this.authInfo = {
      ...val,
    };
  }

  authInfo = {
    userName: '',
    idCard: '',
    idCardType: '',
    pictureFacade: '',
    pictureObverse: '',
  };

  cardTypeList = [
    { id: '1', name: '居民身份证' },
    { id: '2', name: '军官证' },
    { id: '3', name: '港澳台居民往来内地(大陆)通行证' },
    { id: '4', name: '护照' },
  ];

  idToCardType = {
    1: '居民身份证',
    2: '军官证',
    3: '港澳台居民往来内地(大陆)通行证',
    4: '护照',
  };

  authRules = {
    userName: [
      { required: true, message: '请输入真实姓名' },
    ],
    idCardType: [
      { required: true, message: '请选择证件类型' },
    ],
    idCard: [
      { required: true, message: '请输入证件号码' },
    ],
  };

  submit() {
    this.form.validate(async (valid: boolean) => {
      if (valid) {
        if ([cardSide1, cardFail].includes(this.authInfo.pictureFacade)) {
          this.$notify.error('请上传证件照片');
        } else if (this.authInfo.idCardType === '1' && [cardSide2, cardFail].includes(this.authInfo.pictureObverse)) {
          this.$notify.error('请上传身份证反面照片');
        } else {
          this.loading = true;
          try {
            const res = await submitAuth({
              name: this.authInfo.userName,
              number: this.authInfo.idCard,
              type: this.authInfo.idCardType,
              pictureFacade: this.authInfo.pictureFacade,
              pictureObverse: this.authInfo.pictureObverse,
            }) as { state: boolean; message: string };
            if (res.state) {
              this.$message.success('身份信息已提交审核！');
              this.$emit('change');
            } else {
              this.$notify.error(res.message);
            }
          } finally {
            this.loading = false;
          }
        }
      }
    });
  }

  baseUrl = process.env.NODE_ENV === 'production' ? process.env.VUE_APP_API_BASE_URL : '/';

  loading = false;

  statusToText = {
    0: '已认证',
    1: '审核中...',
    2: '重新提交',
  };

  handleUploadSuccess(res: PictureUploadRes) {
    if (res.state) {
      this.$message.success('上传成功');
      if (res.pictureFacade) {
        this.authInfo.pictureFacade = res.pictureFacade;
      } else if (res.pictureObverse) {
        this.authInfo.pictureObverse = res.pictureObverse;
      }
    } else {
      this.$notify.error(res.message);
    }
  }

  handleUploadError(err: { message: string }) {
    this.$message.error(err.message);
  }

  mounted() {
    this.authInfo = {
      ...this.value,
    };
  }
}
